import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck } from 'lucide-react';
export const PurchaseSection = () => {
  return <section id="compra" className="py-16 md:py-24 px-4 bg-forest-950 relative" data-id="element-83">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-grass-500/15 blur-[150px] rounded-full pointer-events-none" data-id="element-84" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-forest-500/10 blur-[150px] rounded-full pointer-events-none" data-id="element-85" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-87">
          <h2 className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide mb-6" data-id="element-88">
            HOY TENÉS DOS OPCIONES
          </h2>
          <p className="text-xl text-forest-300 font-medium" data-id="element-89">
            Seguir entrenando al azar…
          </p>
          <p className="text-xl text-white font-semibold mt-2" data-id="element-90">
            o empezar a entrenar con una metodología creada para el arquero
            moderno.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-forest-900 border-2 border-grass-400 rounded-2xl p-8 md:p-12 shadow-[0_0_50px_rgba(130,194,72,0.2)]" data-id="element-91">
          <div className="text-center mb-8" data-id="element-92">
            <p className="text-forest-300 font-bold tracking-widest uppercase mb-2" data-id="element-93">
              ACCEDÉ HOY A:
            </p>
            <h3 className="font-anton text-5xl md:text-6xl text-grass-400 uppercase tracking-wide" data-id="element-94">
              Arquero PRO System
            </h3>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-10" data-id="element-95">
            <div data-id="element-96">
              <p className="font-bold text-white mb-4 text-lg" data-id="element-97">
                Y empezá a desarrollar:
              </p>
              <ul className="space-y-3" data-id="element-98">
                {['Técnica profesional', 'Reflejos reales', 'Lectura táctica', 'Mentalidad competitiva', 'Seguridad dentro del arco'].map((item, i) => <li key={i} className="flex items-center gap-3 text-forest-100 font-medium" data-id="element-99">
                    <Check className="text-grass-400" size={20} data-id="element-100" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-forest-950 rounded-xl p-6 border border-forest-800 flex flex-col justify-center items-center text-center" data-id="element-101">
              <p className="text-forest-400 line-through text-2xl font-bold mb-1" data-id="element-102">
                $49.990
              </p>
              <p className="font-anton text-6xl text-white tracking-wide mb-2" data-id="element-103">
                $19.990
              </p>
              <p className="text-grass-400 font-semibold text-sm uppercase tracking-wider" data-id="element-104">
                Pago único — Acceso inmediato
              </p>
            </div>
          </div>

          <div className="text-center space-y-4" data-id="element-105">
            <a href="https://checkout.abastecedordigital.shop/cart/52030992056640:1" className="block w-full bg-grass-400 text-forest-950 font-anton text-2xl md:text-3xl uppercase tracking-wide py-6 px-8 rounded-xl shadow-[0_0_20px_rgba(130,194,72,0.5)] hover:shadow-[0_0_40px_rgba(130,194,72,0.7)] hover:scale-[1.02] transition-all duration-300" data-id="element-106">
              QUIERO SER ARQUERO PRO →
            </a>
            <div className="flex items-center justify-center gap-2 text-forest-300 text-sm font-medium" data-id="element-107">
              <ShieldCheck size={16} data-id="element-108" />
              <span data-id="element-109">Acceso inmediato • Garantía • Pago seguro</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};